module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.category), function(c, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 text-left m-t-10"
    }, [_vm._v("\n               \n              "), _c('label', {
      staticClass: "bg-green label label-text-60-p cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.changeCategoryAdd(c, false)
        }
      }
    }, [_vm._v("全選")]), _vm._v(" \n              "), _c('label', {
      staticClass: "bg-red label label-text-60-p cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.changeCategoryAdd(c, true)
        }
      }
    }, [_vm._v("全取消")]), _vm._v("\n               \n            ")]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name) + " "), _c('small', [_vm._v(_vm._s(c.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [_c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_remove),
        expression: "c.is_remove"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.category_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_remove) ? _vm._i(c.is_remove, null) > -1 : (c.is_remove)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_remove,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_remove", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_remove", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.category_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, [_vm._l((c.product_list), function(p, index) {
      return _c('li', {
        key: index,
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_remove),
          expression: "p.is_remove"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_remove) ? _vm._i(p.is_remove, null) > -1 : (p.is_remove)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_remove,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_remove", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_remove", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'p-' + p.product_id + '-is-add'
        }
      })])]), _vm._v(" "), _vm._l((p.combine_list), function(combine, index) {
        return _c('div', {
          key: index
        }, [_c('span', {
          staticClass: "text-15",
          class: {
            'combine-gray': combine.is_remove
          }
        }, [_c('i', {
          staticClass: "fa fa-caret-right",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  " + _vm._s(combine.name) + " "), _c('small', [_vm._v(_vm._s(combine.remark))])]), _vm._v(" "), _c('div', {
          staticClass: "text-right inline-block block-checkbox"
        }, [_c('span', {
          staticClass: "checkbox-addmenu"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (combine.is_remove),
            expression: "combine.is_remove"
          }],
          staticClass: "css-checkbox",
          attrs: {
            "type": "checkbox",
            "id": 'com-' + combine.combine_id + '-is-add'
          },
          domProps: {
            "checked": Array.isArray(combine.is_remove) ? _vm._i(combine.is_remove, null) > -1 : (combine.is_remove)
          },
          on: {
            "input": function($event) {
              return _vm.changeCombineAdd(c, p, combine)
            },
            "change": function($event) {
              var $$a = combine.is_remove,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(combine, "is_remove", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(combine, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(combine, "is_remove", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "css-label css-label-add",
          attrs: {
            "for": 'com-' + combine.combine_id + '-is-add'
          }
        })])])])
      })], 2)])
    }), _vm._v(" "), _vm._l((c.package_list), function(pa, index) {
      return _c('li', {
        key: index,
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(pa.name) + " "), _c('small', [_vm._v(_vm._s(pa.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (pa.is_remove),
          expression: "pa.is_remove"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": pa.package_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(pa.is_remove) ? _vm._i(pa.is_remove, null) > -1 : (pa.is_remove)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, pa)
          },
          "change": function($event) {
            var $$a = pa.is_remove,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(pa, "is_remove", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(pa, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(pa, "is_remove", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": pa.package_id + '-is-add'
        }
      })])])])])
    })], 2)])])])
  }), _vm._v(" "), _vm._l((_vm.accessory), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(o.name) + " "), _c('small', [_vm._v(_vm._s(o.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((o.product_list), function(p, index) {
      return _c('li', {
        key: index,
        staticClass: "card-product"
      }, [_c('div', {}, [_vm._v("\n                    " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [_c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_remove),
          expression: "p.is_remove"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_remove) ? _vm._i(p.is_remove, null) > -1 : (p.is_remove)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(o, p)
          },
          "change": function($event) {
            var $$a = p.is_remove,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_remove", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_remove", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": p.product_id + '-is-add'
        }
      })])]), _vm._v(" "), _vm._l((p.combine_list), function(combine, index) {
        return _c('div', {
          key: index
        }, [_c('span', {
          staticClass: "text-15 text-light-gray"
        }, [_c('i', {
          staticClass: "fa fa-caret-right",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  " + _vm._s(combine.name) + " "), _c('small', [_vm._v(_vm._s(combine.remark))])]), _vm._v(" "), _c('div', {
          staticClass: "text-right inline-block block-checkbox"
        }, [_c('span', {
          staticClass: "checkbox-addmenu"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (combine.is_remove),
            expression: "combine.is_remove"
          }],
          staticClass: "css-checkbox",
          attrs: {
            "type": "checkbox",
            "id": combine.combine_id + '-is-add'
          },
          domProps: {
            "checked": Array.isArray(combine.is_remove) ? _vm._i(combine.is_remove, null) > -1 : (combine.is_remove)
          },
          on: {
            "input": function($event) {
              return _vm.changeProductAdd(o, p, combine)
            },
            "change": function($event) {
              var $$a = combine.is_remove,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(combine, "is_remove", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(combine, "is_remove", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(combine, "is_remove", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "css-label css-label-add",
          attrs: {
            "for": combine.combine_id + '-is-add'
          }
        })])])])
      })], 2)])
    }), 0)])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoFrom
    }
  }, [_vm._v("\n      上一步\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoNext
    }
  }, [_vm._v("\n      完成菜單\n    ")])]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [_c('h4', [_vm._v("\n          訂購與否或顯示隱藏\n        ")]), _vm._v(" "), _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" \"不加入\" 為新增菜單時，將勾選的項目排除。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "text-left"
  }, [_c('br'), _vm._v("\n        1.  商品分類與商品與各商品組合\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-b-5 text-left p-x-15"
  }, [_c('div', {
    staticClass: "text-right inline-block block-checkbox text-15",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "text-dark-gray text-13"
  }, [_vm._v("不加入")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 m-b-5 text-left p-x-15 m-t-10"
  }, [_c('div', {
    staticClass: "text-right inline-block block-checkbox text-15",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "text-dark-gray text-13"
  }, [_vm._v("不加入")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c5f7d44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrJoinMenuTemp.vue
// module id = 2347
// module chunks = 1